import { Paged } from 'api/common/types/Page';
import Http from '../../common/services/Http';
import { BudgetGeneralityDefaultDto } from './models/BudgetGeneralityDefaultDto';
import { BudgetGeneralityDefaultSearchCriteria } from './models/BudgetGeneralityDefaultSearchCriteria';

class BudgetGeneralityDefaultsService {
    public getById (id: string) {
        return Http.get<BudgetGeneralityDefaultDto>('budget-generality-defaults/' + id);
    }

    public getList (criteria: BudgetGeneralityDefaultSearchCriteria) {
        return Http.get<Paged<BudgetGeneralityDefaultDto>>('budget-generality-defaults', criteria);
    }

    public getCatalog () {
        return Http.get<BudgetGeneralityDefaultDto[]>('budget-generality-defaults/catalog');
    }

    public create (model: BudgetGeneralityDefaultDto): Promise<string> {
        return Http.post('budget-generality-defaults', model);
    }

    public update (model: BudgetGeneralityDefaultDto) {
        return Http.put('budget-generality-defaults', model);
    }

    public remove (model: BudgetGeneralityDefaultDto) {
        return Http.put('budget-generality-defaults/deactivate', model);
    }
}

export default new BudgetGeneralityDefaultsService();
